import $ from 'jquery';

require( 'select2' );

const formatDate = ( date ) => {
	let d     = new Date( date );
	let month = ( d.getMonth() + 1 ).toString();
	let year  = d.getFullYear();
	if ( month.length < 2 ) {
		month = '0' + month;
	}
	return [ month, year ].join( '-' );
}

const brand_select_field         = $( '#search-brand-select' );
const model_select_field         = $( '#search-model-select' );
const type_select_field          = $( '#search-type-select' );
const product_group_select_field = $( '#search-product-group' );
const $submit_search_button      = $( '.extended__form-submit' );

brand_select_field.select2( {
	allowClear:  true,
	placeholder: psh_vars.brand,
} );

brand_select_field.on( 'select2:open', function ( e ) {
	$( 'input.select2-search__field' ).prop( 'placeholder', psh_vars.search_for + psh_vars.brand );
} );

model_select_field.select2( {
	allowClear:     true,
	placeholder:    psh_vars.model,
	templateResult: formatModel
} );

model_select_field.on( 'select2:open', function ( e ) {
	$( 'input.select2-search__field' ).prop( 'placeholder', psh_vars.search_for + psh_vars.model );
} );

type_select_field.select2( {
	allowClear:     true,
	placeholder:    psh_vars.type,
	templateResult: formatState
} );

type_select_field.on( 'select2:open', function ( e ) {
	$( 'input.select2-search__field' ).prop( 'placeholder', psh_vars.search_for + psh_vars.type );
} );

product_group_select_field.select2( {
	allowClear:  true,
	placeholder: psh_vars.product_group,
} );

product_group_select_field.on( 'select2:open', function ( e ) {
	$( 'input.select2-search__field' ).prop( 'placeholder', psh_vars.search_for + psh_vars.product_group );
} );

function formatModel( state ) {
	if ( !state.id ) {
		return state.text;
	}

	var $state = $(
		'<div class="single-type">' +
		'<span></span> ' +
		'<span><b>' + state.text + '</b></span>' +
		'<span>' + state.title + '</span> ' +
		'</div>'
	);
	return $state;
}

function formatState( state ) {
	if ( !state.id ) {
		return state.text;
	}

	var $state = $(
		'<div class="single-type">' +
		'<span>' + state.element.getAttribute( 'data-amount' ) + '</span> ' +
		'<span><b>' + state.text + '</b></span>' +
		'<span>' + state.title + '</span> ' +
		'</div>'
	);
	return $state;
}

$( window ).on( 'load', () => {
	brand_select_field.val( '' );

	model_select_field.empty();
	model_select_field.append( '<option value="" disabled>' + psh_vars.select_model + '</option>' );

	type_select_field.empty();
	type_select_field.append( '<option disabled>' + psh_vars.select_type + '</option>' );
} );

brand_select_field.on( 'change', ( e ) => {
	$.ajax( {
		type:       'POST',
		url:        psh_vars.rest_route.psh_brand_model,
		data:       {
			args: { brand: e.target.value }
		},
		beforeSend: () => {
			$submit_search_button.prop( "disabled", true );
			model_select_field.prop( 'disabled', true );
			model_select_field.next().addClass( 'select2-container--loading' );
			model_select_field.append( '<option value="' + psh_vars.loading + '" title="' + psh_vars.loading + '" selected>' + psh_vars.loading + '</option>' );
			type_select_field.prop( 'disabled', true );
		},
		success:    ( result ) => {
			model_select_field.prop( 'disabled', false );
			model_select_field.next().removeClass( 'select2-container--loading' );
			if ( result.data ) {
				model_select_field.empty();
				model_select_field.data( 'model', e.target.value );

				type_select_field.empty();
				type_select_field.append( '<option value="" selected>' + psh_vars.type + '</option>' );
				model_select_field.append( '<option value="" title="' + psh_vars.no_selected + '" selected disabled>' + psh_vars.no_selected + '</option>' );

				result.data[ 0 ].Models.forEach( line => {
					const data     = { line };
					let date_range = ''

					if ( data.line.ModelConstructionDateFrom ) {
						let from_date = formatDate( data.line.ModelConstructionDateFrom );
						let from      = psh_vars.from + ' ';
						let to_date   = '';
						let to        = '';

						if ( data.line.ModelConstructionDateTo ) {
							from    = '';
							to_date = formatDate( data.line.ModelConstructionDateTo );
							to      = ' ' + psh_vars.to + ' ';
						}

						date_range = from + from_date + to + to_date;
					}

					model_select_field.append( '<option value="' + data.line.ModelAndModelDesign + '" title="' + date_range + '">' + data.line.ModelAndModelDesign + '</option>' );
				} );

				model_select_field.select2( {
					allowClear:     true,
					placeholder:    "Model",
					templateResult: formatModel
				} );

			}
		}
	} );
} );

model_select_field.on( 'change', ( e ) => {
	$.ajax( {
		type:       'POST',
		url:        psh_vars.rest_route.psh_brand_model,
		data:       {
			args: {
				brand:               model_select_field.data( 'model' ),
				modelAndModelDesign: e.target.value,
			}
		},
		beforeSend: () => {
			$submit_search_button.prop( "disabled", true );
			type_select_field.prop( 'disabled', true );
			type_select_field.next().addClass( 'select2-container--loading' );
			type_select_field.append( '<option value="' + psh_vars.loading + '" title="' + psh_vars.loading + '" selected>' + psh_vars.loading + '</option>' );
		},
		success:    result => {
			type_select_field.prop( 'disabled', false );
			type_select_field.next().removeClass( 'select2-container--loading' );

			if ( result.data ) {
				type_select_field.empty();

				if ( !result.data.Engines ) {
					type_select_field.append( '<option value="" disabled>' + psh_vars.no_type + '</option>' );
					return;
				}

				Object.entries( result.data.Engines ).forEach( line => {
					let engine_type_string = line[ 0 ];
					type_select_field.append( '<option value="" title="' + psh_vars.no_selected + '" selected disabled>' + psh_vars.no_selected + '</option>' );
					type_select_field.append( '<optgroup label="' + engine_type_string + '">' );

					line[ 1 ].forEach( engine => {
						let data       = engine;
						let date_range = '';

						if ( data.ConstructionDateFrom ) {
							let from_date = formatDate( data.ConstructionDateFrom );
							let from      = psh_vars.from + ' ';
							let to_date   = '';
							let to        = '';

							if ( data.ConstructionDateTo ) {
								from    = '';
								to_date = formatDate( data.ConstructionDateTo );
								to      = ' ' + psh_vars.to + ' ';
							}

							date_range = from + from_date + to + to_date;
						}

						let dateTo = '';
						if ( data.ConstructionDateTo ) {
							dateTo = data.ConstructionDateTo
						}

						let dateFrom = '';
						if ( data.ConstructionDateFrom ) {
							dateFrom = data.ConstructionDateFrom
						}

						let labeldata = [
							data.CapacityCubicRounded.toFixed( 1 ),
							data.TypeDesignation,
							data.OutputMetricHpRounded + psh_vars.pk,
						];

						labeldata = labeldata.filter( val => val );


						const option_value = data.Number + '|' + data.Type;
						const option_label = labeldata.join( ' - ' );

						type_select_field.append( '<option value="' + option_value + '" data-amount="' + data.CapacityCubic + ' ' + psh_vars.ccm + '" title="' + date_range + '">' + option_label + '</option>' );
					} );
					type_select_field.append( '<optgroup/>' );

				} );
			}
		}
	} );
} );

type_select_field.on( 'change', ( e ) => {
	if ( $( e.target ).val().length > 0 ) {
		$submit_search_button.prop( "disabled", false );
	} else {
		$submit_search_button.prop( "disabled", true );
	}
} );

$submit_search_button.on( 'click', ( e ) => {
	e.preventDefault();
	let form = document.querySelector( '.search-form--extended' );

	if ( !form ) {
		form = document.querySelector( '.search-form-home--extended' );
	}

	if ( type_select_field.val().length <= 0 ) {
		return;
	}

	const formData         = new FormData( form );
	let concat_engine_type = formData.get( 'engine_type' );
	let type_number        = concat_engine_type.split( '|' )[ 0 ];
	let type               = concat_engine_type.split( '|' )[ 1 ];

	$( '.kntype' ).val( type );
	$( '.kntype-number' ).prop( 'value', type_number );

	form.submit();
} );
